import { useAuthContext } from '@context/Auth';
import { SIGN_IN } from '@router/path';
import { PropsWithChildren, useEffect } from 'react';
import { createSearchParams, useLocation, useNavigate } from 'react-router-dom';
import * as React from 'react';

const AuthGuard = (props: PropsWithChildren) => {
  const { children } = props;
  const navigate = useNavigate();
  const location = useLocation();
  const { isSignIn } = useAuthContext();

  useEffect(() => {
    if (!isSignIn) {
      navigate(
        {
          pathname: SIGN_IN,
          search: createSearchParams({ from: location.pathname }).toString()
        },
        {
          replace: true
        }
      );
    }
  }, [navigate, isSignIn, location]);

  return <>{isSignIn && children}</>;
};

export default AuthGuard;
